const PERMISSION_KEY= "personalize:nebula_orders";
const PAGE_URL = {
    NEBULA_ORDERS_PAGE: "/admin/personalize/nebula-orders"
}

export {PERMISSION_KEY, PAGE_URL}

